module.exports = __webpack_public_path__ + "static/media/hero-img.2f461ecc.png";